import React from 'react';
import { Eye } from 'lucide-react';

/**
 * Fase A1 · el aviso de que las contraseñas están a la vista, en el listado.
 *
 * Lo único que queda de la franja que hubo aquí. Por orden:
 *
 *   · el RECUENTO se retiró — se pedía para saber a quién le falta, y eso lo responde el filtro
 *   · el CONTADOR subió al candado de la barra — la ventana es de quien mira, no de la pantalla
 *   · el FILTRO se integró con los demás (Negocio, Rol, Estado, Activo), porque es uno más
 *
 * Esto se queda **donde ocurre**: las columnas acaban de aparecer en ESTA tabla y la consulta que
 * ha quedado registrada es la de ESTE listado. El candado sólo lleva el estado de la ventana.
 */
export function AvisoContrasenasVisibles({ visible }) {
  if (!visible) return null;
  return (
    <div className="mb-3 flex items-center gap-2 rounded-v25-lg border border-v25-line bg-v25-surface-sunken px-3 py-2">
      <Eye size={15} className="shrink-0 text-v25-ink-500" />
      <span className="text-[12px] text-v25-ink-700">
        Las contraseñas están visibles en la tabla. Esta consulta ha quedado registrada.
      </span>
    </div>
  );
}
